import {RootStore} from "store/useRootStore"
import {Environment} from "dto/env/env"
import {makeAutoObservable} from "mobx";

export class EnvironmentStore {
    rootStore: RootStore
    env?: Environment

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore
        makeAutoObservable(this)
    }

    setEnv(env: Environment) {
        this.env = env
    }
}